import { Box, Typography } from "@mui/material";
import noDataImage from "../../../assets/images/no-data.svg";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

const EmptyState = ({
  title,
  message,
  showImage = true,
  image,
}: {
  title?: string;
  message?: string;
  showImage?: boolean;
  image?: ReactNode;
}) => {
  const { t } = useTranslation("common");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: showImage ? "75px" : 0,
      }}
    >
      {showImage
        ? image || (
            <img src={noDataImage} alt="not-found" width={100} height={100} />
          )
        : null}
      <Typography
        sx={{
          color: "black",
          mt: showImage ? "26px" : 0,
          fontWeight: "500",
          fontSize: 20,
        }}
      >
        {title || t("list.noResultFound", "No result found")}
      </Typography>
      {message && (
        <Typography
          sx={{
            color: "black",
            fontWeight: "300",
            fontSize: 15,
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyState;
